module.exports = __webpack_public_path__ + "img/8C.a46a54d9.png";